import React, { useState } from "react";

// Chakra imports
import { Flex, useColorModeValue, Badge, VStack, Switch, FormControl, FormLabel, Spinner } from "@chakra-ui/react";

// Custom components
import { BlockMapWhiteLogo, BlockMapDevLogo, BlockLogo, BlockWhiteLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

// i18n
import { useTranslation } from 'react-i18next';

// Constants
import constants from "providers/Constants";

export function SidebarBrand({ collapsed = false }) {
  const { t } = useTranslation();
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  // Environment state
  const [currentEnv, setCurrentEnv] = useState(constants.getCurrentEnvironment());
  const [isLoading, setIsLoading] = useState(false);

  // Handle environment switch
  const handleEnvSwitch = (isChecked) => {
    const newEnv = isChecked ? 'PRODUCTION' : 'SANDBOX';
    setIsLoading(true);

    // Show toast notification
    constants.showToast('info', t('Switching to {{environment}} environment...', { environment: newEnv }));

    // Switch environment with reload
    constants.switchEnvironment(newEnv, true);
    setCurrentEnv(newEnv);
  };

  // Choose different logos for expanded vs collapsed
  const ExpandedLogo = logoColor === "white" ? BlockMapWhiteLogo : BlockMapDevLogo;
  const CollapsedLogo = logoColor === "white" ? BlockWhiteLogo : BlockLogo;

  return (
    <>
      {/* Increase top padding when collapsed so the logo clears the notification banner */}
      <Flex align='center' justify='center' direction='column' pt={collapsed ? 8 : 0} w='100%'>
        {collapsed ? (
          <CollapsedLogo h='72px' w='72px' my='0px' mx='auto' color={logoColor} />
        ) : (
          <ExpandedLogo h='100px' w='170px' my='0px' mx='auto' color={logoColor} />
        )}
      </Flex>
      <Flex align='center' direction='column' display={collapsed ? 'none' : 'flex'}>
        {/* Environment Chip and Toggle */}
        <VStack spacing={3} mt={2} mb={3} mr={7}>
          {/* Environment Display Chip */}
          <Badge
            colorScheme={currentEnv === 'PRODUCTION' ? 'green' : 'red'}
            variant="solid"
            px={3}
            py={1}
            borderRadius="full"
            fontSize="xs"
            fontWeight="bold"
          >
            {currentEnv}
          </Badge>
        </VStack>

        <VStack spacing={3} mt={2} mb={3} mr={3}>
          {/* Environment Toggle Switch */}
          <FormControl display="flex" alignItems="center" justifyContent="center">
            <FormLabel
              htmlFor="env-switch"
              mb="0"
              fontSize="xs"
              color={logoColor}
              opacity={isLoading ? 0.4 : 0.7}
              mr={2}
            >
              {t('Sandbox')}
            </FormLabel>
            {isLoading ? (
              <Spinner size="sm" color={logoColor} />
            ) : (
              <Switch
                id="env-switch"
                size="sm"
                colorScheme={currentEnv === 'PRODUCTION' ? 'green' : 'red'}
                isChecked={currentEnv === 'PRODUCTION'}
                onChange={(e) => handleEnvSwitch(e.target.checked)}
                isDisabled={isLoading}
              />
            )}
            <FormLabel
              htmlFor="env-switch"
              mb="0"
              fontSize="xs"
              color={logoColor}
              opacity={isLoading ? 0.4 : 0.7}
              ml={2}
            >
              {t('Production')}
            </FormLabel>
          </FormControl>
        </VStack>

        <HSeparator mb='20px' />
      </Flex>
    </>
  );
}

export default SidebarBrand;
